import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';

/**
 * Sets the value for each ref in the provided list.
 *
 * @template T - Type of the value the refs point to.
 * @param {T} val - The value to set.
 * @param {...MutableRefList<T>} refs - List of refs or ref callbacks.
 */
function setRef(val) {
  for (var _len = arguments.length, refs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    refs[_key - 1] = arguments[_key];
  }
  refs.forEach(function (ref) {
    if (typeof ref === 'function') ref(val);else if (ref != null) _Object$assign(ref, {
      current: val
    });
  });
}

/**
 * Merges multiple refs into a single ref callback.
 *
 * @template T - Type of the value the refs point to.
 * @param {...MutableRefList<T>} refs - List of refs or ref callbacks.
 * @returns {RefCallback<T>} - A ref callback that sets the value for each ref in the list.
 */
function mergeRefs() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return function (val) {
    var _context;
    return setRef.apply(void 0, _concatInstanceProperty(_context = [val]).call(_context, refs));
  };
}

export { mergeRefs, setRef };
//# sourceMappingURL=mutableRefs.js.map
